export * from './turn-on-fullscreen.directive';



// WEBPACK FOOTER //
// ./src/app/directives/turn-on-fullscreen/index.ts